import { peerIdFromMultihash } from '@libp2p/peer-id';
import { multiaddr } from '@multiformats/multiaddr';
import * as Digest from 'multiformats/hashes/digest';
export function toPbPeerInfo(peer, connection) {
    const output = {
        id: peer.id.toMultihash().bytes,
        multiaddrs: (peer.multiaddrs ?? []).map((m) => m.bytes),
        connection
    };
    return output;
}
export function fromPbPeerInfo(peer) {
    if (peer.id == null) {
        throw new Error('Invalid peer in message');
    }
    const multihash = Digest.decode(peer.id);
    return {
        id: peerIdFromMultihash(multihash),
        multiaddrs: (peer.multiaddrs ?? []).map((a) => multiaddr(a))
    };
}
//# sourceMappingURL=utils.js.map